// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Μετακινήθηκε ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Η ενέργεια ' + p['label'] + ' ολοκληρώθηκε',
  accButtonProgressStatus: (p: { label: string }) =>
    'Η ενέργεια ' + p['label'] + ' είναι σε εξέλιξη',
  accColorPalette: () => 'Παλέτα χρωμάτων',
  accColorSwatch: () => 'Δείγμα χρώματος',
  accCommandKey: () => 'Εντολή',
  accContextMenuLabel: () => 'ενέργειες',
  accControlKey: () => 'Κλείσιμο',
  accPositionAfter: () => 'μετά από',
  accPositionBefore: () => 'πριν από',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Πατήστε παρατεταμένα τα πλήκτρα ' +
    p['keyPressed'] +
    ' και shift, έπειτα χρησιμοποιήστε τα πλήκτρα βέλους για αναδιάταξη.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Καταχωρίστε μια ολοκληρωμένη ημερομηνία όπως: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Καταχωρίστε έναν μήνα και έτος όπως: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Ετικέτα',
  chart_labelGroup: () => 'Ομάδα',
  chart_labelSeries: () => 'Σειρά',
  chart_labelValue: () => 'Τιμή',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  checkbox_helpForCheckbox: () => 'Βοήθεια για πλαίσιο ελέγχου',
  checkbox_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  checkbox_selected: () => 'Ενεργοποιήθηκε το πλαίσιο επιλογής',
  checkbox_unselected: () => 'Το πλαίσιο επιλογής δεν είναι ενεργοποιημένο',
  close: () => 'Κλείσιμο',
  collection_apply: () => 'Εφαρμογή',
  collection_cancel: () => 'Ακύρωση',
  collection_loaded: () => 'Έγινε φόρτωση',
  collection_loading: () => 'Φόρτωση',
  collection_noData: () => 'Δεν υπάρχουν δεδομένα για εμφάνιση.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Αναπροσαρμογή μεγέθους στήλης',
  collection_resizeColumnMenu: () => 'Αναπροσαρμογή μεγέθους στήλης...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Εισάγετε έναν αριθμό μεταξύ ' + p['MIN'] + ' και ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Επιλέξτε όλες τις γραμμές',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Επιλογή σειράς ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Αύξουσα σειρά',
  collection_sortColumnMenu: () => 'Ταξινόμηση στήλης',
  collection_sortDescendingSubMenu: () => 'Φθίνουσα σειρά',
  collection_sortDisabled: () => 'Χωρίς δυνατότητα ταξινόμησης',
  collection_sortEnabled: () => 'Με δυνατότητα ταξινόμησης',
  collection_width: () => 'Πλάτος',
  colorPicker_label: () => 'Επιλογέας χρώματος',
  confirmation: () => 'Επιβεβαίωση',
  datePicker_currentDate: () => 'Τρέχουσα ημερομηνία',
  datePicker_goToToday: () => 'Μετάβαση στη σημερινή ημέρα',
  datePicker_label: () => 'Εργαλείο επιλογής ημερομηνίας',
  datePicker_month: () => 'Μήνας',
  datePicker_months: () => 'Μήνες',
  datePicker_next: () => 'Επόμενη',
  datePicker_nextDecade: () => 'Επόμενη δεκαετία',
  datePicker_nextMonth: () => 'Επόμενος μήνας',
  datePicker_prev: () => 'Προηγούμενη',
  datePicker_prevDecade: () => 'Προηγούμενη δεκαετία',
  datePicker_prevMonth: () => 'Προηγούμενος μήνας',
  datePicker_restricted: () => 'Περιορισμένο',
  datePicker_selected: () => 'Επιλεγμένο',
  datePicker_today: () => 'Σήμερα',
  datePicker_weekNum: (p: { NUM: string }) => 'Εβδομάδα ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Αριθμός εβδομάδας',
  datePicker_year: () => 'Έτος',
  datePicker_years: () => 'Έτη',
  diagram_promotedLink: () => '1 δεσμός',
  diagram_promotedLinkAriaDesc: () => 'Έμμεσο',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' δεσμοί',
  error: () => 'Σφάλμα',
  expandableList_expandCollapseInstructionText: () =>
    'Χρησιμοποιήστε τα πλήκτρα-βέλη για ανάπτυξη και σύμπτυξη',
  expandableList_groupCollapse: () => 'Συμπτύχθηκε',
  expandableList_groupExpand: () => 'Αναπτύχθηκε',
  filePicker_addFiles: () => 'Προσθήκη αρχείων',
  filePicker_dropzonePrimaryText: () => 'Μεταφορά και απόθεση',
  filePicker_dropzoneSecondaryText: () =>
    'Επιλέξτε ένα αρχείο ή πραγματοποιήστε απόθεση ενός αρχείου εδώ',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Επιλέξτε αρχεία ή πραγματοποιήστε απόθεση αρχείων εδώ',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Κάντε αποστολή ενός αρχείου τη φορά',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Δεν μπορείτε να αποστείλετε αρχεία τύπου ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'άγνωστος',
  formControl_clear: () => 'Εκκαθάριση',
  formControl_day: () => 'Ημέρα',
  formControl_empty_segment: () => 'Κενό',
  formControl_helpAvailable: () => 'Διατίθεται βοήθεια',
  formControl_hide: () => 'Απόκρυψη',
  formControl_hour: () => 'Ώρα',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Συμπληρώσατε το όριο ' +
    ((
      { one: new Intl.NumberFormat('el').format(p['CHARACTER_LIMIT']) + '-χαρακτήρα' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('el').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('el').format(p['CHARACTER_LIMIT']) + '-χαρακτήρων') +
    '.',
  formControl_loading: () => 'Φόρτωση',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Μπορείτε να εισαγάγετε έως ' + p['MAX_LENGTH'] + ' χαρακτήρες.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Υπέρβαση μέγιστου μήκους ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Απομένουν ' + p['CHARACTER_COUNT'] + ' χαρακτήρες.',
  formControl_millisecond: () => 'Χιλιοστό του δευτερολέπτου',
  formControl_minute: () => 'Λεπτό',
  formControl_month: () => 'Μήνας',
  formControl_readOnly: () => 'Μόνο για ανάγνωση',
  formControl_requiredMessageDetail: () => 'Καταχωρίστε μια τιμή.',
  formControl_second: () => 'Δευτερόλεπτο',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'Επιλογή ' + p['n'] + ' τιμών.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Έχετε συμπληρώσει το μέγιστο όριο ' + p['max'] + ' επιλογών',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Επιλέξτε από ' + p['min'] + ' έως ' + p['max'] + ' τιμές.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Επιλέξτε τουλάχιστον ' + p['min'] + ' τιμές.',
  formControl_show: () => 'Εμφάνιση',
  formControl_year: () => 'Έτος',
  gantt_labelDate: () => 'Ημερομηνία',
  gantt_labelEnd: () => 'Λήξη',
  gantt_labelLabel: () => 'Ετικέτα',
  gantt_labelRow: () => 'Σειρά',
  gantt_labelStart: () => 'Έναρξη',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Δεν βρέθηκε τμήμα που να συμφωνεί.',
  indexer_keyboardInstructionText: () => 'Πατήστε το πλήκτρο Εnter για να επιλέξετε τιμή.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Μεταξύ ' + p['FROM_SECTION'] + ' και ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Πατήστε δύο φορές και κρατήστε πατημένο για να εισέλθετε στη λειτουργία κινήσεων και έπειτα σύρετε προς τα επάνω ή προς τα κάτω για να προσαρμόσετε την τιμή.',
  info: () => 'Πληροφορίες',
  inputColor_selectColor: () => 'Επιλογή χρώματος',
  inputDateMask_date_cleared: () => 'Έγινε εκκαθάριση ημερομηνίας',
  inputDateMask_dayPlaceholder: () => 'ηη',
  inputDateMask_empty_segment: () => 'Κενό',
  inputDateMask_monthPlaceholder: () => 'μμ',
  inputDateMask_yearPlaceholder: () => 'εεεε',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Εισαγάγετε μια ημερομηνία που να είναι ίδια με ' + p['max'] + ' ή προγενέστερη.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Εισαγάγετε μια ημερομηνία που να είναι ίδια με  ' + p['min'] + ' ή μεταγενέστερη.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Εισαγάγετε μια διαθέσιμη ημερομηνία.',
  inputDatePicker_instruction: () =>
    'Πατήστε το πλήκτρο Tab για να αποκτήσετε πρόσβαση στο ημερολόγιο.',
  inputDatePicker_selectDate: () => 'Επιλέξτε μια ημερομηνία',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Καταχωρίστε έναν μήνα και έτος ίσο ή προγενέστερο από ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Καταχωρίστε έναν μήνα και έτος ίσο ή μεταγενέστερο από ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Καταχωρίστε έναν αριθμό.',
  inputNumber_decrease: () => 'Μείωση',
  inputNumber_increase: () => 'Αύξηση',
  inputPassword_hidden: () => 'Ο κωδικός πρόσβασης κρύφτηκε',
  inputPassword_hide: () => 'Απόκρυψη κωδικού πρόσβασης',
  inputPassword_show: () => 'Εμφ. κωδ. πρόσβασης',
  inputSensitiveText_hidden: () => 'Απόκρυψη ευαίσθητου κειμένου',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Εισαγάγετε μια ώρα που να είναι ίδια με ' + p['max'] + ' ή προγενέστερη.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Εισαγάγετε μια ώρα που να είναι ίδια με ' + p['min'] + ' ή μεταγενέστερη.',
  inputTimeMask_time_cleared: () => 'Εκκαθάριση ώρας',
  labelNone: () => 'Καμία',
  list_msgFetchCompleted: () => 'Έγινε φόρτωση',
  list_msgFetchingData: () => 'Φόρτωση',
  list_suggestion: () => 'Πρόταση',
  menu_stateLoading: () => 'Φόρτωση',
  messageToast_allMessagesClosed: () => 'Όλες οι αναδυόμενες ειδοποιήσεις έκλεισαν.',
  message_close: () => 'Κλείσιμο',
  message_confirmation: () => 'Επιτυχία',
  message_error: () => 'Σφάλμα',
  message_info: () => 'Πληροφορίες',
  message_navigationFromMessagesRegion: () =>
    'Εισαγωγή σε περιοχή μηνυμάτων. Πατήστε F6 για πλοήγηση.',
  message_navigationToMessagesRegion: () =>
    'Η περιοχή μηνυμάτων έχει νέα μηνύματα. Πατήστε F6 για πλοήγηση.',
  message_navigationToTouch: () => 'Η περιοχή μηνυμάτων έχει νέα μηνύματα.',
  message_warning: () => 'Προειδοποίηση',
  noData_message: () => 'Δεν υπάρχουν στοιχεία για εμφάνιση',
  overflowItemLabel: () => 'Περισσότερες καρτέλες',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Πατήστε δύο φορές για να κλείσετε το ανοιχτό αναδυόμενο παράθυρο.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Αναδυόμενο παράθυρο εισαγωγής. Πατήστε το F6 για πλοήγηση μεταξύ του αναδυόμενου μενού και του σχετικού στοιχείου ελέγχου.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Άνοιξε το αναδυόμενο παράθυρο. Πατήστε το F6 για πλοήγηση μεταξύ του αναδυόμενου μενού και του σχετικού στοιχείου ελέγχου.',
  progressIndeterminate: () => 'Σε εξέλιξη',
  radioButton_checked: () => 'Το κουμπί επιλογής ενεργοποιήθηκε',
  radioButton_selected: () => 'Το κουμπί επιλογής επιλέχθηκε',
  radioButton_unchecked: () => 'Το κουμπί επιλογής δεν ενεργοποιήθηκε',
  radioButton_unselected: () => 'Το κουμπί επιλογής δεν επιλέχθηκε',
  radio_helpForRadio: () => 'Βοήθεια για το κουμπί επιλογής',
  radio_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  selectMultiple_apply: () => 'Εφαρμογή',
  selectMultiple_back: () => 'Πίσω',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Χρησιμοποιήστε τα πλήκτρα αριστερού και δεξιού βέλους για να επισημάνετε τις επιλεγμένες τιμές.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Πατήστε Backspace ή Delete για να καταργηθεί η επιλεγμένη τιμή.',
  selectMultiple_selectedValues: () => 'Επιλεγμένες τιμές',
  selectMultiple_showSelectedValues: () => 'Εμφάνιση μόνο των επιλεγμένων τιμών.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Επιλέχθηκαν ' + p['VALUE_COUNT'] + ' τιμές.',
  select_addToList: () => 'Προσθήκη σε λίστα',
  select_addToListAvailable: () => 'Η προσθήκη σε λίστα είναι διαθέσιμη',
  select_closeDropdown: () => 'Πατήστε το πλήκτρο Escape για κλείσιμο.',
  select_moreSearchOptions: () => 'Περισσότερες επιλογές αναζήτησης',
  select_moreSearchOptionsAvailable: () => 'Διατίθενται περισσότερες επιλογές αναζήτησης',
  select_noMatchesFound: () => 'Δεν βρέθηκαν αποτελέσματα.',
  select_oneMatchFound: () => 'Βρέθηκε ένα αποτέλεσμα',
  select_requiredMessageDetail: () => 'Επιλέξτε μια τιμή.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' αποτελέσματα',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Βρέθηκαν ' + p['TOTAL_SIZE'] + ' ή περισσότερα αποτελέσματα',
  selectorAll_deselectAll: () => 'Αναίρεση επιλογής όλων',
  selectorAll_selectAll: () => 'Επιλογή όλων',
  selector_selected: () => 'Ενεργοποιήθηκε το πλαίσιο επιλογής',
  selector_unselected: () => 'Το πλαίσιο επιλογής δεν είναι ενεργοποιημένο',
  sheet_close: () => 'Κλείσιμο',
  switch_off: () => 'Απενεργοποιημένο',
  switch_on: () => 'Ενεργό',
  tabBarNavigationList_removeCueText: () => 'Με δυνατότητα κατάργησης',
  tabBar_tabContainsErrors: () => 'Περιέχει σφάλματα',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Καταργήθηκε το ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'έχει μενού περιβάλλοντος',
  tabbar_labelMoveLeft: () => 'Μετακίνηση αριστερά',
  tabbar_labelMoveRight: () => 'Μετακίνηση δεξιά',
  tabbar_labelRemove: () => 'Αφαίρεση',
  timeComponent_tooltipZoomIn: () => 'Μεγέθυνση',
  timeComponent_tooltipZoomOut: () => 'Σμίκρυνση',
  timeConverter_parseError: () => 'Εισαγάγετε μια ολοκληρωμένη ώρα.',
  train_current: () => 'Τρέχον',
  train_message_type: () => 'Τύπος μηνύματος',
  train_not_visited: () => 'Χωρίς επίσκεψη',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Βήμα ' + p['currentStep'] + ' από ' + p['numberOfSteps'],
  train_visited: () => 'Με επίσκεψη',
  userAssistance_learnMore: () => 'Μάθετε περισσότερα',
  userAssistance_required: () => 'Απαιτείται',
  vis_clearSelection: () => 'Εκκαθάριση επιλογής',
  vis_drillable: () => 'Με δυνατότητα ανάπτυξης/σύμπτυξης',
  vis_invalidData: () => 'Μη έγκυρα δεδομένα',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' από ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Επιλογή κυλιόμενου μηνύματος',
  vis_marqueeZoomTooltip: () => 'Μεγέθυνση κυλιόμενου μηνύματος',
  vis_noData: () => 'Δεν υπάρχουν δεδομένα για εμφάνιση',
  vis_panTooltip: () => 'Μετατόπιση',
  vis_stateCollapsed: () => 'Συμπτύχθηκε',
  vis_stateExpanded: () => 'Αναπτύχθηκε',
  vis_stateLoaded: () => 'Έγινε φόρτωση',
  vis_stateLoading: () => 'Φόρτωση',
  vis_stateSelected: () => 'Επιλεγμένο',
  vis_stateUnselected: () => 'Μη επιλεγμένο',
  warn: () => 'Προειδοποίηση'
};
export default bundle;
